import { Table, Input, Space, Button, Checkbox } from "antd";
import React, { useState, useRef, useEffect } from "react";
import {
  UploadOutlined,
  PrinterOutlined,
  DeleteOutlined,
  EditOutlined,
  BarsOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import TextArea from "antd/es/input/TextArea";
import { LayoutData } from "../Structur/Aconlayout";

export const EvidenzDatenListe = ({
  gruppe,
  title,
  dataSource,
  loading,
  handleOnEMailsClick,
  handleOnDetailClick,
}) => {
  const { mainContainerHeight } = LayoutData();

  const getColumns = () => {
    const columns = [
      {
        title: "EMails",
        key: "action1",
        dataIndex: "recnr",
        width: 50,
        render: (recnr, record) => (
          <>
            <span
              onClick={() => {
                handleOnEMailsClick(record);
              }}
              style={{ cursor: "pointer" }}
            >
              <BarsOutlined style={{ fontSize: 20 }} />
            </span>
          </>
        ),
      },
      {
        title: "Detail",
        key: "aktion2",
        width: 50,
        dataIndex: "recnr",
        render: (recnr, record) => (
          <span
            onClick={() => {
            handleOnDetailClick(record);
            }}
            style={{ cursor: "pointer" }}
          >
            <EditOutlined style={{ fontSize: 20 }} />
          </span>
        ),
      },
      {
        title: "Name",
        dataIndex: "name",
        width: 200,
        minWidth: 120,
        align: "left",
        render: (text) => <b>{text}</b>,
      },
      {
        title: "Gruppe",
        dataIndex: "gruppe",
        fixed: "left",
        width: 200,
        minWidth: 120, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <>{text}</>,
      },
      {
        title: "Plz",
        dataIndex: "plz",
        fixed: "right",
        width: 60,
        minWidth: 40, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <>{text}</>,
      },
      {
        title: "Ort",
        dataIndex: "ort",
        fixed: "left",
        width: 200,
        minWidth: 120, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <>{text}</>,
      },
    ];
    return columns;
  };
  const cancel = () => {};
  return (
    <>
      <Table
        title={title}
        rowSelection={false}
        size="small"
        columns={getColumns()}
        dataSource={dataSource}
        bordered
        loading={loading}
        fixed
        pagination={{
          // pageSize: 50,
          onChange: cancel,
        }}
        scroll={{
          y: mainContainerHeight > 380 ? mainContainerHeight - 180 : 120,
        }}
      />
    </>
  );
};
